module.exports = __webpack_public_path__ + "img/exemple-resolution.0a1ad629.jpg";